import Vendor from 'data/Vendor';
import BrandVendor from './BrandVendor';

export interface Logo {
  id: number;
  name: string;
  path: string;
  fileType: string;
  createdOn: string;
};

export default interface Brand {
  id: number;
  name: string;
  description: string;
  code: string;
  media?: Logo[];
  oldMedia?: Logo[];
  keywords: string[];
  vendor: Vendor | null;
  /* Automation Properties Added */
  baseUrl?: string;
  consumerKey?: string;
  consumerSecret?: string;
  authenticationUrl?: string;
  isMaterialApiEnabled?: boolean;
  isStockApiEnabled?: boolean;
  isSalesOrderApiEnabled?: boolean;
  brandVendor?: BrandVendor;
  title?: string;
  trustedSince?: string;
  seoTitle?: string;
  seoDescription?: string;
  isParentBrand?: boolean;
  selectedBrandsIds?: number[];
  parentId?: number;
  brands?: Brand[];
  configuration?: BrandConfiguration;
  businessUnitId?: number;
  businessUnit?: {
    id: number;
    name: string;
    code: string;
  };
  isBuyNowEnabled?: boolean;
  buyNowConsumerKey?: string;
  isAssigned?: boolean;
};

export type PartialBrand = Pick<Brand, 'name' | 'media' | 'description' | 'keywords'> & { vendorId: number };

export const empty: Omit<Brand, 'id'> = {
  name: '',
  code: '',
  description: '',
  keywords: [],
  vendor: null,
  media: [{
    id: 0,
    name: '',
    path: '',
    fileType: '',
    createdOn: ''
  }],
  /* Automation Properties Added */
  baseUrl: '',
  authenticationUrl: '',
  consumerKey: '',
  consumerSecret: '',
  isMaterialApiEnabled: false,
  isStockApiEnabled: false,
  isSalesOrderApiEnabled: false,
  title: '',
  trustedSince: '',
  seoTitle: '',
  seoDescription: '',
  isParentBrand: false,
  selectedBrandsIds: [],  
};


export interface BrandConfiguration {
  rentReminderDays: number;
  firstReminderDays: number | undefined;
  secondReminderDays: number | undefined;
  thirdReminderDays: number | undefined;
  autoApproveEnabled: boolean;
  autoApproveAfterDays: number | undefined;
  brandIds?: number[] | undefined;
};
